var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight17X13 = function SvgArrowRight17X13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.116 7.165-5.083 5.083a1.214 1.214 0 0 1-1.717-1.718l3-3.019h-11.1a1.214 1.214 0 0 1 0-2.429h11.1l-3-3A1.221 1.221 0 1 1 11.051.364l5.065 5.066a1.235 1.235 0 0 1 .364.867 1.166 1.166 0 0 1-.364.868Z"
  })));
};
export default SvgArrowRight17X13;